<div class="row" style="margin-left: 5px">
    <div class="col-4" *ngFor="let button of buttons; let i = index"
         (click)="setEduction(i)" style="margin-bottom: 5px">
        <button type="button" class="btn btn-outline-primary"
                [ngStyle]="{ 'background-color': buttons[i].isClickable ? '#182F7C' : 'white' }">
            <div class="d-flex">
                <img src="{{buttons[i].icon}}"/>
                <span [ngStyle]="{ 'color': buttons[i].isClickable ? 'white' : '#182F7C' }"
                        style="color: #182F7C!important;font-size: 12px">
                    {{buttons[i].title}}</span>
            </div>
        </button>
    </div>
</div>
